import client from '../../client';
import {
  GET_SUBS_DATA,
  GET_SUBS_DATA_SUCCESS,
  GET_SUBS_DATA_FAIL,
  GET_ACTIVE_SUB_DATA,
  GET_ACTIVE_SUB_DATA_SUCCESS,
  GET_ACTIVE_SUB_DATA_FAIL,
  GET_SUBS_DRILL_DATA,
  GET_SUBS_DRILL_DATA_SUCCESS,
  GET_SUBS_DRILL_DATA_FAIL,
  GET_LOOKUP_DATA,
  GET_LOOKUP_DATA_SUCCESS,
  GET_LOOKUP_DATA_FAIL
} from '../constants/subs';

export const getSubsData = (params, graphId) => dispatch => {
  dispatch({
    type: GET_SUBS_DATA,
    graphId
  });

  client
    .get('/asubs', { params })
    .then(res => {
      dispatch({
        type: GET_SUBS_DATA_SUCCESS,
        data: res.data,
        graphId
      });
    })
    .catch(error => {
      dispatch({
        type: GET_SUBS_DATA_FAIL,
        error,
        graphId
      })
    });
}

export const fetchActiveSubData = (params, graphId) => dispatch => {
  dispatch({
    type: GET_ACTIVE_SUB_DATA,
    graphId
  });
  client
    .get('/activesubs', { params })
    .then(res => {
      dispatch({
        type: GET_ACTIVE_SUB_DATA_SUCCESS,
        activeSubs: res.data,
        graphId
      });
    })
    .catch(error => {
      dispatch({
        type: GET_ACTIVE_SUB_DATA_FAIL,
        error,
        graphId
      })
    });
}

export const getSubsDrillData = (params) => dispatch => {
  dispatch({
    type: GET_SUBS_DRILL_DATA
  });

  client
    .get('/subs/drill', { params })
    .then(res => {
      dispatch({
        type: GET_SUBS_DRILL_DATA_SUCCESS,
        data: res.data
      });
    })
    .catch(error => {
      dispatch({
        type: GET_SUBS_DRILL_DATA_FAIL,
        error
      })
    })
}

export const getSubMethodLookupData = (params) => dispatch => {
  dispatch({
    type: GET_LOOKUP_DATA
  });

  client
    .get('/lookup', { params })
    .then(res => {
      dispatch({
        type: GET_LOOKUP_DATA_SUCCESS,
        data: res.data
      });
    })
    .catch(error => {
      dispatch({
        type: GET_LOOKUP_DATA_FAIL,
        error
      })
    })
}



// WEBPACK FOOTER //
// ./src/redux/actions/subs.js